import { InputSummary } from '../../input-summary';
import InputSummaryUtils from '../../../helper/input-summary/input-summary-util';
import { UnitValue } from '../../data-structures/unit-value.model';
import {v4 as uuid} from 'uuid';
import AnessaListItemUtil, { AnessaListItem } from '../../anessa-list-item.interface';
import { PeriodType } from '../plant-specifications/fuel.model';


export interface FinancialCapexInterface {
  name: string;
  uuid: string;
  description: string;
  cost: UnitValue;
  connectionType: string;
  connectionToggle: boolean;
  quantity: UnitValue;
  period: UnitValue;
  lifetime: UnitValue;
  estimated: boolean;
  estimationPercentage: UnitValue;
}

export class FinancialCapex implements AnessaListItem {
  name: string;
  uuid: string;
  description: string;
  cost: UnitValue;
  connectionType: string
  connectionToggle: boolean;
  quantity: UnitValue;
  period: UnitValue;
  lifetime: UnitValue;
  estimated: boolean;
  estimationPercentage: UnitValue;

  constructor(param: FinancialCapexInterface = {
    name: '',
    uuid: null,
    description: '',
    cost: new UnitValue(),
    connectionType: '',
    connectionToggle: false,
    quantity: new UnitValue(),
    period: new UnitValue(),
    lifetime: new UnitValue(),
    estimated: false,
    estimationPercentage: new UnitValue()
  }) {
    this.name = param.name;
    this.uuid = param.uuid ? param.uuid : uuid();
    this.description = param.description;
    this.cost = new UnitValue(param.cost);
    this.connectionType = param.connectionType ? param.connectionType : PeriodType.FEEDAMOUNT;
    this.connectionToggle = param.connectionToggle ?? false;
    this.quantity = new UnitValue(param.quantity);
    this.period = new UnitValue(param.period);
    this.lifetime = new UnitValue(param.lifetime);
    this.lifetime.unit = '000000000000000000001305';
    this.estimated = param.estimated;
    this.estimationPercentage = new UnitValue(param.estimationPercentage);
  }

  static deepCopy(capex: FinancialCapex) {
    let copy;
    if (capex) {
      copy = new FinancialCapex(capex);
      return copy;
    }
    throw new Error('Capex deep copy failed');
  }

  getInputSummary(path: string[]) {
    const inputSummary = new InputSummary();
    inputSummary.inputs = InputSummaryUtils.performPush(inputSummary.inputs, FinCapexPropName.cost, this.cost, [...path, 'cost']);
    inputSummary.inputs = InputSummaryUtils.performPush(inputSummary.inputs, FinCapexPropName.lifetime, this.lifetime, [...path, 'lifetime']);
    if(this.connectionToggle){
      inputSummary.inputs = InputSummaryUtils.performPush(inputSummary.inputs, FinCapexPropName.connectionType, this.connectionType, [...path, 'connectionType']);
      inputSummary.inputs = InputSummaryUtils.performPush(inputSummary.inputs, FinCapexPropName.quantity, this.quantity, [...path, 'quantity']);
    }
    return inputSummary;
  }

  getUuidForPath(): string {
    return AnessaListItemUtil.getUuidForPath(this.uuid);
  }

  static arrayDeepCopy(items: FinancialCapex[]) {
    const copy: FinancialCapex[] = [];
    if (items && items.length) {
      for (const c of items) {
        copy.push(new FinancialCapex(c));
      }
    }
    return copy;
  }
}

export enum FinCapexPropName {
  name = 'INPUT_SUMMARY.FINANCIAL.NAME',
  cost = 'INPUT_SUMMARY.FINANCIAL.COST',
  lifetime = 'INPUT_SUMMARY.FINANCIAL.CAPEX.LIFETIME',
  quantity = 'INPUT_SUMMARY.FINANCIAL.QUANTITY',
  period = 'INPUT_SUMMARY.FINANCIAL.PERIOD',
  connectionType = 'INPUT_SUMMARY.FINANCIAL.CAPEX.CONNECTION_TYPE',
  id_name = 'name',
  id_cost = 'cost',
  id_lifetime = 'lifetime',
}

export enum FinCapexErrorMessage {
  MissingName = 'INPUT_SUMMARY.FINANCIAL.CAPEX.MISSING_NAME',
}


export interface CapexImportRow {
  name: string,
  description: string,
  cost: number,
  currency: string,
  connection: string,
  quantity: number,
  quantity_unit: string,
  period_unit: string,
  lifetime: number
}